import React from 'react';
import { Construction } from 'lucide-react';

const PlaceholderPage = ({ title, description, icon: Icon, color = '#E8471E' }) => (
  <div style={{
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', minHeight: '60vh', textAlign: 'center', gap: '1rem'
  }}>
    <div style={{
      width: 72, height: 72, borderRadius: 20,
      background: `${color}18`, display: 'flex',
      alignItems: 'center', justifyContent: 'center'
    }}>
      {Icon ? <Icon size={32} color={color} /> : <Construction size={32} color={color} />}
    </div>
    <h2 style={{ fontSize: '1.4rem', fontWeight: 600, color: '#f0ede8' }}>{title}</h2>
    <p style={{ fontSize: '0.95rem', color: '#666', maxWidth: 360, lineHeight: 1.6 }}>
      {description || 'This feature is currently in development. It will be available in the next release.'}
    </p>
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      background: 'rgba(200, 148, 26, 0.1)', border: '1px solid rgba(200, 148, 26, 0.25)',
      color: '#C8941A', fontSize: '0.78rem', fontWeight: 600,
      letterSpacing: '0.08em', padding: '5px 14px', borderRadius: 20,
      textTransform: 'uppercase'
    }}>
      Coming Soon
    </div>
  </div>
);

export const BudgetPage = () => (
  <PlaceholderPage
    title="Budget & Expense Tracker"
    description="Track your income and expenses, set budgets by category, and get insights into your spending habits."
    color="#E8471E"
  />
);

export const LearnPage = () => (
  <PlaceholderPage
    title="Financial Education"
    description="Explore bite-sized modules on budgeting, investing, debt management, and building long-term wealth."
    color="#4a9eff"
  />
);

export const GoalsPage = () => (
  <PlaceholderPage
    title="Savings Goals"
    description="Set savings targets, track your progress, and stay motivated as you work towards your financial goals."
    color="#C8941A"
  />
);

export const SettingsPage = () => (
  <PlaceholderPage
    title="Account Settings"
    description="Manage your profile, update your password, configure notifications, and personalise your experience."
    color="#888"
  />
);
